export enum VisitorStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
